import { render, staticRenderFns } from "./parentsInformation2.vue?vue&type=template&id=1118c216&scoped=true&"
import script from "./parentsInformation2.vue?vue&type=script&lang=js&"
export * from "./parentsInformation2.vue?vue&type=script&lang=js&"
import style0 from "./parentsInformation2.vue?vue&type=style&index=0&id=1118c216&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1118c216",
  null
  
)

export default component.exports